//@flow
import { graphql } from 'react-relay';
import { generateMutation } from './generateMutation';

import type { OutputType } from './generateMutation';

const taggedQuery = graphql`
    mutation followProfileMutation($input: FavoriteDesignProfileInput!) {
        favoriteDesignProfile(input: $input) {
            user {
                favorites(types: [DESIGNER]) {
                    edges {
                        node {
                            serviceId
                            anchor {
                                sourceId
                            }
                        }
                    }
                }
            }
        }
    }
`;

type Args = {|
    page: string,
    designerId: string,
    designerName: string,
    userId: string,
|};

export const followProfile: (Object, Args) => Promise<OutputType> = generateMutation(taggedQuery);
